import Vuex from 'vuex'
import Vue from 'vue'
import ai from './modules/ai'
import auth from './modules/auth'
import links from './modules/links'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ai,
    auth,
    links
  }
})
